import "css/App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import React, { lazy, Suspense } from "react";
import indexDashboard from "client/pages/Dashboard/index";
import indexCurriculum from "client/pages/Curriculum/index";
import indexProfile from "client/pages/Profile/index";
import indexCourses from "client/pages/Courses/index";
import SignUp from "client/templates/AuthTemplates/signup";
import Login from "client/templates/AuthTemplates/login";
import ForgotPassword from "client/templates/AuthTemplates/forgotPassword";
import { AuthProvider } from "client/services/contexts/AuthServiceContext";
import PrivateRoute from "client/utils/PrivateRoute";
import loaders from "client/components/loaders";
import indexWebDevStudentApplication from "client/pages/Certifications/WebDevelopmentStudent/ApplicationForm/index";
import indexWebDevGrowApplication from "client/pages/Certifications/WebDevelopmentGrow/ApplicationForm/index";
import indexWebdevScreening from "client/pages/Certifications/WebDevelopmentStudent/Screening/index";
import indexWebDevStudentReserveSeat from "client/pages/Certifications/WebDevelopmentStudent/ReserveSeat/index";

export const pathDashboard = indexDashboard.path;
export const pathCurriculum = indexCurriculum.path;
export const pathProfile = indexProfile.path;
export const pathCourses = indexCourses.path;
export const pathWebDevStudentScreening = indexWebdevScreening.path;
export const pathWebDevStudentApplicationForm =
  indexWebDevStudentApplication.path;
export const pathWebDevGrowApplicationForm = indexWebDevGrowApplication.path;
export const pathWebDevStudentReserveSeat = indexWebDevStudentReserveSeat.path;

export const ComposerDashboard = lazy(() =>
  import("client/pages/Dashboard/composer")
);
export const ComposerCurriculum = lazy(() =>
  import("client/pages/Curriculum/composer")
);
export const ComposerProfile = lazy(() =>
  import("client/pages/Profile/composer")
);
export const ComposerCourses = lazy(() =>
  import("client/pages/Courses/composer")
);

export const ComposerWebDevStudentScreening = lazy(() =>
  import("client/pages/Certifications/WebDevelopmentStudent/Screening/composer")
);

export const ComposerWebDevStudentApplicationForm = lazy(() =>
  import(
    "client/pages/Certifications/WebDevelopmentStudent/ApplicationForm/composer"
  )
);

export const ComposerWebDevGrowApplicationForm = lazy(() =>
  import(
    "client/pages/Certifications/WebDevelopmentGrow/ApplicationForm/composer"
  )
);

export const ComposerWebDevStudentReserveSeat = lazy(() =>
  import(
    "client/pages/Certifications/WebDevelopmentStudent/ReserveSeat/composer"
  )
);

function App() {
  return (
    <>
      <AuthProvider>
        <Router>
          <Suspense fallback={loaders.commonLoader()}>
            <Switch>
              <PrivateRoute exact path="/" component={ComposerDashboard} />
              {/* Auth Route */}
              <Route path="/sign-up" component={SignUp} />
              <Route path="/login" component={Login} />
              <Route path="/forgot-password" component={ForgotPassword} />
              {/*  */}
              <PrivateRoute
                path={pathCurriculum}
                component={ComposerCurriculum}
              />
              <PrivateRoute
                path={pathDashboard}
                component={ComposerDashboard}
              />
              <PrivateRoute path={pathProfile} component={ComposerProfile} />
              <PrivateRoute path={pathCourses} component={ComposerCourses} />

              {/* Screening Page */}
              <PrivateRoute
                path={pathWebDevStudentScreening}
                component={ComposerWebDevStudentScreening}
              />

              {/* Application Form */}
              <PrivateRoute
                path={pathWebDevStudentApplicationForm}
                component={ComposerWebDevStudentApplicationForm}
              />

              <PrivateRoute
                path={pathWebDevGrowApplicationForm}
                component={ComposerWebDevGrowApplicationForm}
              />

              {/* Reserve Seat Page */}
              <PrivateRoute
                path={pathWebDevStudentReserveSeat}
                component={ComposerWebDevStudentReserveSeat}
              />
            </Switch>
          </Suspense>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;
